import { Action, Dispatch } from "redux";
import size from "lodash/size";
import ProjectService from "../../services/projectService";
import UserOperationsService from "../../services/operationsService";
import { ActionTypes } from "./actionTypes";
import {
    IApplicationState,
    IQueues,
    IProject, AppError,
    ErrorCode,
} from "../../models/applicationState";
import { createAction, createPayloadAction, IPayloadAction } from "./actionCreators";

export default interface IUserOperationsActions {
    createQueue(queueObject: any, payload: any): Promise<void>;
    dataRevisionEditJson(jsonObjectPayload: any, projectName: string): Promise<void>;
    deleteUserQueue(queues: IQueues): Promise<IQueues>;
    batchPredictionForAllBlobs(projectName: string, queueName: string): Promise<void>;
    userAllQueues(projectName: string): Promise<IQueues[]>;
    deleteFileFromQueue(projectName: string, queueName: string, fileName: string): Promise<any>;
    analyseFileJsonResult(projectName: string, queueName: string, fileName: string): Promise<void>;
    deleteTestFiles(userid: string): Promise<string>;
    getAllInvalidFiles(fileType:String) : Promise<void>;
    submitErrorProcess(projectName:String,fileType:String) : Promise<void>;
    invoiceManagement() :Promise<void>;
    documentMangement(): Promise<void>;
    documentMangementByDate(fromdate:string, todate:string): Promise<void>
    orderMangement(): Promise<void>;
    orderMangementByDate(fromdate:string, todate:string): Promise<void>
    orderMangementByDate(fromdate:string, todate:string): Promise<void>;
    orderMgt_CheckLock(reqDetailsId: string, rowkey:string, keyword:string);

}

/**
 * Create user Queue
 * @param queueObject - Queue Object
 */
export function createQueue(queueObject: any, payload: any):
    (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        const userOperationService = new UserOperationsService();
        const createdUser = await userOperationService.createUserQueue(queueObject, payload);
        return createdUser;
    };
}

/**
 * Data Revision
 * @param data revision Object
 */
export function dataRevisionEditJson(jsonObjectPayload: any, projectName: string):
    (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        const userOperationService = new UserOperationsService();
        const dataRevisionData = await userOperationService.dataRevisionJson(jsonObjectPayload, projectName);
        return dataRevisionData;
    };
}

/**
 * Load All user Queues
 * @param queueObject - Queue Object
 */
export function userAllQueues(projectName: string):
    (dispatch: Dispatch, getState: () => IApplicationState) => Promise<IQueues[]> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        const userOperationService = new UserOperationsService();
        const allQueues = await userOperationService.userAllQueues(projectName);
        dispatch(loadAllUserQueues(allQueues));
        return allQueues;
    };
}

export function deleteUserQueue(queue: IQueues)
: (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
    const userOperationService = new UserOperationsService();
    const deletedQueue = await userOperationService.deleteUserQueue(queue);
    return deletedQueue;
    // dispatch(deleteUserQueueAction(model));
    };
}


export function deleteTestFiles(userid: string)
: (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
    const userOperationService = new UserOperationsService();
    const deletedQueue = await userOperationService.deleteTestFiles(userid);
  //  dispatch(deleteUserQueueAction());
    return deletedQueue;
    
    };
}


export function getAllInvalidFiles(fileType: string)
: (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
    const userOperationService = new UserOperationsService();
    const invalidFiles = await userOperationService.getInValidFiles(fileType);
    return invalidFiles;
    
    };
}
export function invoiceManagement()
: (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
    const userOperationService = new UserOperationsService();
    const invalidFiles = await userOperationService.getInvoiceManagementFiles();
    return invalidFiles;
    
    };
}

export function documentMangement()
: (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
    const userOperationService = new UserOperationsService();

    const invalidFiles = await userOperationService.getDocumentManagementFiles();
    return invalidFiles;
    
    };
}


export function documentMangementByDate(fromdate:string, todate:string)
: (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
    const userOperationService = new UserOperationsService();

    const invalidFiles = await userOperationService.getDocumentManagementFilesbyDate(fromdate, todate);
    return invalidFiles;
    
    };
}


export function orderMangement()
: (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
    const userOperationService = new UserOperationsService();

    const invalidFiles = await userOperationService.getOrderManagementFiles();
    return invalidFiles;
    
    };
}



export function orderMangementByDate(fromdate:string, todate:string)
: (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
    const userOperationService = new UserOperationsService();

    const invalidFiles = await userOperationService.getOrderManagementFilesbyDate(fromdate, todate);
    return invalidFiles;
    
    };
}


export function submitErrorProcess(projectName:String,fileType: string)
: (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
    const userOperationService = new UserOperationsService();
    const invalidFiles = await userOperationService.submitError(projectName,fileType);
    return invalidFiles;
    
    };
}


/**
 * Batch Prediction for all Blobs 
 */
export function batchPredictionForAllBlobs(projectName: string, queueName: string)
: (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
    const userOperationService = new UserOperationsService();
    const predictedData = await userOperationService.processBatchPrediction(projectName, queueName);
    return predictedData;
    // dispatch(deleteUserQueueAction(model));
    };
}

/**
 * Delete File from Queue
 */
export function deleteFileFromQueue(projectName: string, queueName: string, fileName: string)
: (dispatch: Dispatch, getState: () => IApplicationState) => Promise<any> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
    const userOperationService = new UserOperationsService();
    const deletedFile = await userOperationService.deleteFile(projectName, queueName, fileName);
    return deletedFile;
    // dispatch(deleteUserQueueAction(model));
    };
}

/**
 * Analyse File JSON Result
 */
export function analyseFileJsonResult(projectName: string, queueName: string, fileName: string)
: (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
    const userOperationService = new UserOperationsService();
    const analyseResult = await userOperationService.analyseFileResult(projectName, queueName, fileName);
    return analyseResult;
    // dispatch(deleteUserQueueAction(model));
    };
}

export interface ILoadUserQueuesAction extends IPayloadAction<string, any> {
    type: ActionTypes.LOAD_USER_ALL_QUEUE_SUCCESS;
}


/**
 * Delete project action type DELETE_USER_QUEUE_SUCCESS
 */
export interface IDeleteUserQueueAction extends IPayloadAction<string, any> {
    type: ActionTypes.DELETE_USER_QUEUE_SUCCESS;
}

export const loadAllUserQueues = createPayloadAction<ILoadUserQueuesAction>(ActionTypes.LOAD_USER_ALL_QUEUE_SUCCESS);
export const deleteUserQueueAction = createPayloadAction<IDeleteUserQueueAction>(ActionTypes.DELETE_USER_QUEUE_SUCCESS);


export function orderMgt_CheckLock(reqDetailsId: string, rowkey:string, keyword:string)
: (dispatch: Dispatch, getState: () => IApplicationState) => Promise<void> {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
    const userOperationService = new UserOperationsService();

    const lockDetais = await userOperationService.orderMgt_CheckLock(reqDetailsId,rowkey,keyword);
    return lockDetais;
    
    };
}